export default __webpack_public_path__ + "static/media/shuttle.bb472cbd.svg";